export const copilotChatTextAreaId = 'copilot-chat-textarea'
export const copilotChatSearchInputId = 'copilot-chat-topic-search'
export const reviewUserMessage = 'Review'
